import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchChannels } from '../api/channels';
import type { Channel } from '../api/types';
import './HomePage.css';

export function HomePage() {
  const [channels, setChannels] = useState<Channel[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchChannels()
      .then(setChannels)
      .catch(() => setChannels([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="home-page">
      <div className="home-hero">
        <h1>🎧 SecretTalk</h1>
        <p>Discover voice channels from creators you love</p>
      </div>

      {loading ? (
        <div className="home-loading">Loading channels...</div>
      ) : channels.length === 0 ? (
        <div className="home-empty">
          <p>No channels yet. Stay tuned! 🎙️</p>
        </div>
      ) : (
        <div className="home-grid">
          {channels.map((ch) => (
            <Link key={ch.id} to={`/c/${ch.id}`} className="home-card">
              <div className="home-card-avatar">
                {ch.creatorAvatar ? (
                  <img src={ch.creatorAvatar} alt={ch.name} />
                ) : (
                  <span>🎙️</span>
                )}
              </div>
              <div className="home-card-info">
                <h3>{ch.name}</h3>
                <p>{ch.description || ch.category || 'Voice Channel'}</p>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
